import React, { useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import styled from 'styled-components'
import { NewCheckIcon } from '../../Icons/NewCheckIcon'
import { useTranslation } from 'react-i18next'
import ArraySelect from '../../Select/ArraySelect'
import { useEmployeeDataState } from '../../../stores/EmployeeDataProvider'
import useStores from '../../../stores/useStore'
import { isEmptyGuid } from '../../../utils/emptyGuid'
import ModalComponent2 from '../../../components/Modals/ModalComponent2'

const StyledWrapper = styled.div`
  margin: 7px;
  .input-group-text {
    height: 32px;
    display: flex;
    align-items: center;
    padding: 0 10px;
  }

  select {
    min-width: 200px !important;
    height: 32px;
  }
  // select {
  //   min-width: 200px !important;
  // }
  @media (max-width: 410px) {
    select {
      margin-bottom: 20px;
    }
    .input-group-text {
      height: 32px; // maintain consistent height
    }
  }
`

const EmployeeUserSelector = () => {
  const { t } = useTranslation()
  const { accountId, showUserData, setShowUserData, setDeleteAccount } =
    useEmployeeDataState()
  const { uiStore } = useStores()
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false)
  const setUserGroup = () => {
    if (!isEmptyGuid(accountId)) {
      setDeleteAccount(false)
      if (showUserData) {
        setShowDeleteAccountModal(true)
        return
      }
    }
    setShowUserData((prev) => !prev)
  }
  const handleDeleteAccount = (bool) => {
    setDeleteAccount(bool)
    if (bool) {
      setShowUserData(false)
    }
    setShowDeleteAccountModal(false)
  }
  return (
    <StyledWrapper>
      <Form.Label>{t('Subheader:userGroup')}</Form.Label>
      <InputGroup>
        <InputGroup.Text>
          <NewCheckIcon style={{ width: '16px', height: '16px' }} />
        </InputGroup.Text>
        {/*
          accountId ?
            <InputGroup.Text style={{ minWidth: "150px" }}>User</InputGroup.Text>
            : uiStore.allowAccessUserModule ?
              <ArraySelect
                value={showUserData ? "user" : "employee"}
                onChange={() => setShowUserData(prev => !prev)}
                options={[{ id: "employee", displayName: t('header:employees') }, { id: "user", displayName: "User" }]}
              />
              : <InputGroup.Text style={{ minWidth: "150px" }}>{t('header:employees')}</InputGroup.Text>
        */}
        {uiStore.allowAccessUserModule ? (
          <ArraySelect
            value={showUserData ? 'user' : 'employee'}
            onChange={() => setUserGroup()}
            options={[
              { id: 'employee', displayName: t('header:employees') },
              { id: 'user', displayName: 'User' },
            ]}
          />
        ) : !isEmptyGuid(accountId) ? (
          <InputGroup.Text style={{ minWidth: '150px' }}>User</InputGroup.Text>
        ) : (
          <InputGroup.Text style={{ minWidth: '150px' }}>
            {t('header:employees')}
          </InputGroup.Text>
        )}
      </InputGroup>
      {showDeleteAccountModal && (
        <ModalComponent2
          ModalTitle={t('employeesPage:deleteAccountTitle')}
          button1Function={() => handleDeleteAccount(true)}
          button1Text={t('yes')}
          closeButtonText={t('no')}
          BodyPart1={t('employeesPage:deleteAccountBody')}
          functionCancel={() => handleDeleteAccount(false)}
          centered
        ></ModalComponent2>
      )}
    </StyledWrapper>
  )
}

export default EmployeeUserSelector
